<div class="top-nav">
    <div class="top-nav-items">
        <h1 class="title-section" *ngIf="(route$ | async)?.data?.section ">
            {{ (route$ | async).data.section | translate }}
        </h1>

        <div class="wrapper-right">
            <div class="top-nav-items-profil" (click)="toggleDropdownProfil()">
                <div class="top-nav-items-profil-label icon-smash_profil"></div>
            </div>
            <div class="top-nav-items-profil-dropdown" [ngClass]="{'top-nav-items-profil-dropdown-expanded': dropdownProfileToggled}">
                <ul class="top-nav-items-profil-dropdown-list dropdown-list">
                    <div class="top-nav-items-profil-dropdown-header">
                        <h2 *ngIf="identity?.username">
                            {{identity.username}}
                        </h2>
                    </div>
                    <li class="top-nav-items-profil-dropdown-list-item" (click)="goToProfileSettings()">
                        {{ 'PREMIUM_TOPNAV_DROPDOWN_SETTINGS' | translate }}
                    </li>
                    <li class="top-nav-items-profil-dropdown-list-item" (click)="signOut()">
                        {{ 'PREMIUM_TOPNAV_DROPDOWN_LOGOUT' | translate }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
